import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, Label, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import Config from "../../Config";
import { useState, useEffect } from "react";

const RejectModal = ({
    setIsReqRej,
    selectedData,
    reqRejLoading,
    reqRejMutate,
    onboardingReqRejLoading,
    onboardingReqRejMutate,
    // refundReqRejLoading,
    // refundReqRejMutate,
    refundReqLoading,
    refundReqMutate,
    guestReqLoading,
    guestReqMutate
}) => {

    const reqType = selectedData?.type;
    const [rejectionReason, setRejectionReason] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const [error, setError] = useState("");
    const [allowResubmit, setAllowResubmit] = useState(false);

    useEffect(() => {
        if (selectedData) {
            setRejectionReason("");
            setCharacterCount(0);
            setError("");
            setAllowResubmit(false);
        }
    }, [selectedData]);

    const handleReasonChange = (e) => {
        const value = e.target.value;
        if (value.length <= 120) {
            setRejectionReason(value);
            setCharacterCount(value.length);
            setError("");
        }
    };

    const handleRejectSubmit = () => {
        if (!rejectionReason.trim()) {
            setError("Rejection reason is required");
            return;
        }

        if (rejectionReason.trim().length < 10) {
            setError("Rejection reason must be at least 10 characters");
            return;
        }

        if (selectedData?.type === Config.REQUEST_TYPE.ONBOARDING) {
            onboardingReqRejMutate({
                requestId: selectedData?.id,
                reason: rejectionReason.trim()
            });
        } else if (selectedData?.type === Config.REQUEST_TYPE.MOVEOUT) {
            reqRejMutate({
                requestId: selectedData?.id,
                reason: rejectionReason.trim()
            });
        } else if (selectedData?.type === Config.REQUEST_TYPE.GUEST) {
            guestReqMutate({
                requestId: selectedData?.id,
                status: Config.REQUEST_STATUS.REJECTED,
                reason: rejectionReason.trim()
            });
        }
        else {
            refundReqMutate({
                requestId: selectedData?.id,
                status: Config.REQUEST_STATUS.REJECTED,
                reason: rejectionReason.trim(),
                allowResubmit: allowResubmit ? 1 : 0
            });
        }
    };

    const isLoading =
        selectedData?.type === Config.REQUEST_TYPE.ONBOARDING
            ? onboardingReqRejLoading
            : selectedData?.type === Config.REQUEST_TYPE.MOVEOUT
                ? reqRejLoading
                : selectedData?.type === Config.REQUEST_TYPE.GUEST
                    ? guestReqLoading
                    : refundReqLoading;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsReqRej}
            title="Confirm Reject Request"
        >
            <WarningText>
                Are you sure you want to reject this request? Please provide a reason for rejection.
            </WarningText>

            <div className=" space-y-1">
                <Label htmlFor="rejectionReason">Reason *</Label>
                <TextArea
                    id="rejectionReason"
                    value={rejectionReason}
                    onChange={handleReasonChange}
                    placeholder="Please provide a detailed reason for rejecting this request (min. 10 characters)"
                    rows="3"
                    className={error ? "border-red-500" : ""}
                />
                {error && <ErrorText>{error}</ErrorText>}

                <div className="flex items-center justify-between mt-0 mb-2">
                    <HelpText className="mt-0">
                        * Minimum 10 characters required.
                    </HelpText>

                    <CharacterCount>
                        {characterCount}/120
                    </CharacterCount>
                </div>
                {/* <div className="flex justify-between">
                    <div>
                        {error && <ErrorText>{error}</ErrorText>}
                    </div>
                    <CharacterCount>
                        {characterCount}/120
                    </CharacterCount>
                </div>
                <HelpText>
                    * Minimum 10 characters required. This reason will be shared with the tenant.
                </HelpText> */}
                {reqType === Config.REQUEST_TYPE.REFUND && (
                    <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3">
                        <label className="flex items-start gap-3 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={allowResubmit}
                                onChange={(e) => setAllowResubmit(e.target.checked)}
                                className="mt-1 h-4 w-4 rounded border-gray-300 text-primary-color"
                            />

                            <div>
                                <p className="text-sm font-medium text-gray-800">
                                    Allow tenant to resubmit the refund request
                                </p>
                                <p className="text-xs text-gray-500 mt-1">
                                    If enabled, the tenant can submit a refund request after reviewing the rejection reason.
                                </p>
                            </div>
                        </label>
                    </div>
                )}
            </div>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsReqRej(false)}
                    disabled={isLoading}
                >
                    Cancel
                </SideCancelBtn>

                <DeleteBtn
                    onClick={handleRejectSubmit}
                    disabled={isLoading || !rejectionReason.trim() || rejectionReason.trim().length < 10}
                    className={`border  ${isLoading || !rejectionReason.trim() || rejectionReason.trim().length < 10
                        ? "bg-gray-50 text-gray-500 cursor-not-allowed border-gray-500"
                        : "bg-white text-red-500 hover:bg-red-500 hover:text-white border-red-500"}`}
                >
                    {isLoading ? "Processing..." : "Reject Request"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-2`;
const TextArea = tw.textarea`w-full px-3 py-2 border border-gray-300 rounded-lg resize-none`;
const ErrorText = tw.span`text-red-500 text-sm`;
const CharacterCount = tw.span`text-gray-500 text-sm`;
const HelpText = tw.p`text-gray-500 text-xs mt-1`;

export default RejectModal;